export default __webpack_public_path__ + "static/media/ic_asterisk.cf32e859.svg";